module.exports = __webpack_public_path__ + "img/glkgxt.febd0c61.svg";